export interface Job {
  id: string;
  title: string;
  company: string;
  category: string;
  contractType: string;
  salaryMin: number | null;
  salaryMax: number | null;
  city: string;
  description: string;
  requirements: string;
  contactEmail: string;
  contactPhone: string;
  postedAt: string;
}

export const jobCategories = [
  'Technologie',
  'Finance',
  'Santé',
  'Éducation',
  'Marketing',
  'Commerce',
  'Hôtellerie',
  'Agriculture',
  'Artisanat',
  'Administration',
];

export const contractTypes = [
  'CDI',
  'CDD',
  'Stage',
  'Freelance',
  'Temps plein',
  'Temps partiel',
];

export const mockJobs: Job[] = [
  {
    id: 'job-1',
    title: 'Développeur Web Full-Stack (React / Node.js)',
    company: 'DigitalBridge Togo',
    category: 'Technologie',
    contractType: 'CDI',
    salaryMin: 450000,
    salaryMax: 800000,
    city: 'Lomé',
    description:
      'DigitalBridge recherche un développeur full-stack passionné pour concevoir et maintenir des plateformes web innovantes. Vous rejoindrez une équipe dynamique et travaillerez sur des projets à fort impact pour des clients en Afrique et à l\'international.',
    requirements:
      'Maîtrise de React, TypeScript et Node.js · Expérience avec les bases de données relationnelles (PostgreSQL) · Bonne compréhension des API REST · 2+ ans d\'expérience · Esprit d\'équipe et autonomie.',
    contactEmail: 'rh@digitalbridge.tg',
    contactPhone: '+228 90 11 22 33',
    postedAt: '2026-08-19',
  },
  {
    id: 'job-2',
    title: 'Community Manager / Social Media',
    company: 'Wax Studio Agency',
    category: 'Marketing',
    contractType: 'Temps plein',
    salaryMin: 250000,
    salaryMax: 400000,
    city: 'Lomé',
    description:
      'Wax Studio Agency recherche un community manager créatif pour animer les réseaux sociaux de nos clients, créer du contenu engageant et développer leur présence en ligne.',
    requirements:
      'Excellente maîtrise des réseaux sociaux · Compétences en création de contenu visuel · Rédaction en français irréprochable · Connaissance des outils de planification · Sens de la créativité.',
    contactEmail: 'jobs@waxstudio.tg',
    contactPhone: '+228 91 44 55 66',
    postedAt: '2026-08-18',
  },
  {
    id: 'job-3',
    title: 'Infirmier(ère) diplômé(e) d\'État',
    company: 'Clinique Espérance',
    category: 'Santé',
    contractType: 'CDD',
    salaryMin: 300000,
    salaryMax: 450000,
    city: 'Kara',
    description:
      'La Clinique Espérance recherche des infirmiers(ères) diplômé(e)s pour renforcer son équipe soignante. Travail en équipe dans un environnement moderne et bienveillant.',
    requirements:
      'Diplôme d\'État d\'infirmier · Inscription à l\'ordre des infirmiers · Expérience en milieu hospitalier appréciée · Rigueur et sens du service au patient.',
    contactEmail: 'recrutement@clinique-esperance.tg',
    contactPhone: '+228 90 22 33 44',
    postedAt: '2026-08-17',
  },
  {
    id: 'job-4',
    title: 'Professeur de Mathématiques (Lycée)',
    company: 'Collège Les Savoirs',
    category: 'Éducation',
    contractType: 'CDD',
    salaryMin: 200000,
    salaryMax: 350000,
    city: 'Sokodé',
    description:
      'Le Collège Les Savoirs recrute un professeur de mathématiques pour les classes de seconde à terminale. Vous rejoindrez une équipe pédagogique engagée dans la réussite des élèves.',
    requirements:
      'Licence ou Master en mathématiques · Expérience en enseignement · Pédagogie adaptée · Sens de l\'écoute et de la patience.',
    contactEmail: 'direction@collegelessavoirs.tg',
    contactPhone: '+228 90 55 66 77',
    postedAt: '2026-08-16',
  },
  {
    id: 'job-5',
    title: 'Chef de Projet Digital',
    company: 'Apeiron Consulting',
    category: 'Technologie',
    contractType: 'Freelance',
    salaryMin: 500000,
    salaryMax: 900000,
    city: 'Lomé',
    description:
      'Apeiron Consulting recherche un chef de projet digital expérimenté pour piloter des projets de transformation numérique. Vous coordonnerez les équipes techniques et accompagnerez les clients.',
    requirements:
      'Expérience en gestion de projet digital · Connaissance des méthodes agiles · Excellente communication · Capacité à gérer plusieurs projets en parallèle · Anglais professionnel.',
    contactEmail: 'contact@apeiron-consulting.tg',
    contactPhone: '+228 90 88 99 00',
    postedAt: '2026-08-15',
  },
  {
    id: 'job-6',
    title: 'Data Analyst',
    company: 'Insight Analytics',
    category: 'Technologie',
    contractType: 'CDI',
    salaryMin: 400000,
    salaryMax: 700000,
    city: 'Lomé',
    description:
      'Insight Analytics recherche un data analyst pour transformer les données en décisions stratégiques. Vous analyserez les données clients et créerez des tableaux de bord impactants.',
    requirements:
      'Maîtrise de SQL, Python et des outils de visualisation · Esprit analytique · Capacité à raconter une histoire avec les données · Rigueur et curiosité.',
    contactEmail: 'jobs@insight-analytics.tg',
    contactPhone: '+228 91 77 88 99',
    postedAt: '2026-08-14',
  },
  {
    id: 'job-7',
    title: 'Comptable Senior',
    company: 'Cabinet Finances Plus',
    category: 'Finance',
    contractType: 'CDI',
    salaryMin: 350000,
    salaryMax: 600000,
    city: 'Lomé',
    description:
      'Le Cabinet Finances Plus recherche un comptable senior pour gérer le portefeuille de clients PME. Vous serez en charge de la tenue comptable, des déclarations fiscales et du conseil.',
    requirements:
      'Diplôme en comptabilité · Maîtrise de la réglementation fiscale togolaise · Expérience en cabinet appréciée · Maîtrise des logiciels comptables.',
    contactEmail: 'rh@financesplus.tg',
    contactPhone: '+228 90 33 44 55',
    postedAt: '2026-08-13',
  },
  {
    id: 'job-8',
    title: 'Designer UI/UX',
    company: 'CreativeLab',
    category: 'Technologie',
    contractType: 'Stage',
    salaryMin: null,
    salaryMax: null,
    city: 'Lomé',
    description:
      'CreativeLab propose un stage de designer UI/UX pour un(e) étudiant(e) créatif(ve) souhaitant développer ses compétences sur des projets réels. Encadrement par une équipe senior.',
    requirements:
      'Étudiant en design ou autodidacte passionné · Connaissance de Figma · Portfolio · Créativité et sens du détail · Motivation à apprendre.',
    contactEmail: 'studio@creativelab.tg',
    contactPhone: '+228 91 22 33 44',
    postedAt: '2026-08-12',
  },
];